import React, { Component, PropTypes } from 'react';
import {
  NitroSingleSelect
} from 'nitro-components';

class Dropdown extends Component {
  render() {

    const {filter, action, placeholder} = this.props;

    return (
      <NitroSingleSelect
        placeholder={placeholder}
        action={action}
        value={filter.value}
        options={filter.options}
        mandatory={filter.mandatory}
      />
    );
  }
}

Dropdown.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/filter/filters/single-select/Dropdown.js